import { DataAttributeDefinitions } from 'scrivito'

import { pisaContactContactRelationDataClass } from './Pisa/pisaContactContactRelationDataClass'

const attributes: DataAttributeDefinitions = {}

export const ContactContactRelation =
  pisaContactContactRelationDataClass(attributes)
